<html>

<body>
  <div [@routeAnimations]="o && o.activatedRouteData && o.activatedRouteData['animation']" fxFlexFill fxFlex>
  <router-outlet #o="outlet"></router-outlet>
</div>
  <!-- Routed components go here -->
</body>

</html>